import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import useTheme from '@mui/material/styles/useTheme';

import Icon from 'presentation/icons';
import {PasswordRequirementItemProps} from './types';

export function PasswordRequirementItem({msg, isValid, isDirty}: PasswordRequirementItemProps) {
	const {palette} = useTheme();
	const statusColor = isValid ? palette.success.main : palette.error.main;
	const disabledColor = palette.action.active;
	const errorIcon = (
		<Icon
			name={isDirty ? 'error-fill' : 'error-outline'}
			color={isDirty ? statusColor : disabledColor}
		/>
	);
	const validIcon = (
		<Icon name="check-circle-filled" color={isDirty ? statusColor : disabledColor} />
	);

	return (
		<ListItem disablePadding>
			<ListItemIcon sx={{minWidth: 0}}>{isValid ? validIcon : errorIcon}</ListItemIcon>
		<ListItemText
			sx={{ml: 2}}
			primary={msg}
			slotProps={{
				primary: {
					variant: 'body2',
					color: !isDirty ? disabledColor : statusColor,
				},
			}}
		/>
		</ListItem>
	);
}
